export default __webpack_public_path__ + "static/media/8.174f1056.png";